import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";

import ContinueButton from "app/components/common/buttons/Continue";
import Checkbox from "app/components/common/inputs/Checkbox";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import home_car_bg from "app/assets/images/home_car_bg.png";
import home_car_bg_responsive from "app/assets/images/car-bg-Responsive.png";

interface FormData {
  loanType: string;
  terms: boolean;
}

const SelectLoanTypes: React.FC = () => {
  const dispatch = useDispatch();
  const [isAnimating, setIsAnimating] = useState(false);
  const { loanApplication, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<FormData>({
    defaultValues: {
      loanType: "car",
      terms: false,
    },
  });
  const termsChecked = watch("terms");

  const onSubmit = (data: FormData) => {
    const { loanType } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        loanApplication: {
          ...loanApplication,
          loanType,
        },
      })
    );
    dispatch(setStep(1));
  };

  useEffect(() => {
    if (loanApplication?.loanType) {
      reset({ loanType: loanApplication?.loanType });
    }
  }, [loanApplication?.loanType, reset]);

  const handleLinkClick = (e: React.MouseEvent) => {
    setIsAnimating(true);
  };
  let text1 =
    "By submitting your application to Hejaz Auto Finance, you consent to the secure collection, use, and storage of your personal information for the purpose of assessing your eligibility and processing your application, in accordance with the Hejaz Privacy Policy.";
  let text2 =
    " By submitting your application to Hejaz Auto Finance, you consent to the secure collection.";
  //  const [text , setText] = useState<string>(text2)
  const [isExpanded, setIsExpanded] = useState(false);
  const [readMoreText, setReadMoreText] = useState("Read More");

  const handleTextToggle = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    e.preventDefault();

    setIsExpanded(!isExpanded);
    setReadMoreText(isExpanded ? "Read More" : "Read Less");
  };

  return (
    <>
      <div className="relative flex gap-8 -mt-6 home_wrapper max-md:flex-col-reverse">
        <div className="flex flex-col md:items-center md:justify-center w-full pl-4 md:pl-[60px] md:flex-1 ">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full lg:w-[50vw] flex flex-col md:gap-12 max-lg:pt-12 max-md:pt-0"
          >
            <div className="flex flex-col gap-4 md:gap-8">
              <h2 className="text-primary font-Poppins font-bold text-[24px]  text-nowrap  xl:text-[62px] ">
                Hejaz Auto Finance{" "}
              </h2>
              <p className="text-[16px] md:text-[24px] font-medium leading-[24px] font-Mulish text-lightBlue lg:w-[40ch] md:leading-[30px] mx-2 sm:mx-2 md:mx-0">
                Tailored auto loan solutions designed to make vehicle ownership
                simple and stress-free.
              </p>
            </div>
            <div className="mt-6 mb-8">
              <Controller
                name="terms"
                control={control}
                rules={{ required: "You must agree to the Privacy Policy." }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <>
                    <div className="text-left ">
                      <Checkbox
                        id="terms"
                        className="sm:!items-start"
                        removeCheckMargin={true}
                        labelHtml={
                          <>
                            <div className="text-darkgrey text-[12px] md:text-[14px] leading-[24px] font-Mulish font-normal ml-1 flex md:w-[25ch] lg:!w-[45ch]">
                              <span className="max-md:hidden">
                                By submitting your application to Hejaz Auto
                                Finance, you consent to the secure collection,
                                use, and storage of your personal information
                                for the purpose of assessing your eligibility
                                and processing your application, in accordance
                                with the Hejaz Privacy Policy.
                              </span>

                              <span className="md:hidden">
                                {isExpanded ? text1 : text2}
                                <span
                                  className="cursor-pointer md:hidden text-primary"
                                  onClick={handleTextToggle}
                                >
                                  {readMoreText}
                                </span>
                              </span>
                            </div>
                          </>
                        }
                        checked={value}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                      {error && <ErrorsMessage title={error.message} />}
                    </div>
                  </>
                )}
              />
            </div>

            <div className="flex flex-col gap-6">
              <Link
                to="/welcome"
                className={`block text-primary2 w-max text-[16px] font-normal font-Mulish underline transition-opacity duration-300 text-nowrap ${
                  isAnimating ? "opacity-0" : "opacity-100"
                }`}
                onClick={handleLinkClick}
              >
                Sign in to continue an existing application {" >"}
              </Link>
              <ContinueButton
                className="md:!w-[30%] font-semibold font-Mulish w-full max-md:w-[243px] "
                type="submit"
                disabled={!termsChecked}
              >
                Apply
              </ContinueButton>
            </div>
          </form>
        </div>
        <div className="  md:grow md:w-[50vw] flex md:justify-end">
          <img
            src={home_car_bg}
            alt="car_with_bg"
            className="h-[615px] xl:w-[550px] max-lg:w-[375px] max-md:hidden"
          />
          <img
            src={home_car_bg_responsive}
            alt="car_with_bg"
            className="md:h-[350px] sm:h-[300px] xs:h-[250px] w-full md:hidden"
          />
        </div>
      </div>
    </>
  );
};

export default SelectLoanTypes;
